import { useTranslation } from "react-i18next";
import * as z from "zod";

export const usePowerOfAttorneyBillFormSchema = () => {
  const { t } = useTranslation();

  return z.object({
    authorization: z.literal<boolean>(true, {
      errorMap: () => ({
        message: t("common.form.field.errors.required"),
      }),
    }),
    consent: z.literal<boolean>(true, {
      errorMap: () => ({
        message: t("common.form.field.errors.required"),
      }),
    }),
    privacy: z.literal<boolean>(true, {
      errorMap: () => ({
        message: t("common.form.field.errors.required"),
      }),
    }),
  });
};

export type TPowerOfAttorneyBillFormSchema = z.infer<
  ReturnType<typeof usePowerOfAttorneyBillFormSchema>
>;
